import { ProgressBar } from 'react-bootstrap';
import { ToastErrorIcon } from '../../components/icons/ToastErrorIcon';
import styles from './FileProgress.module.scss';

export const FileProgress = ({
  fileName,
  fileSizeBytes,
  downloadedBytes,
  failed,
  parentClassName,
  containerClassName,
}) => {
  const progress = Math.min(Math.floor((downloadedBytes / fileSizeBytes) * 100), 100);

  return (
    <div width="100%" className={`${styles.root} ${parentClassName || ''}`}>
      <div className={`${styles.textContainer} ${containerClassName || ''}`}>
        <div className={styles.fileName}>{fileName}</div>
        {!failed && (
          <div>
            {fileSizeBytes === -1 && '...'}
            {fileSizeBytes !== -1 && `${progress}%`}
          </div>
        )}
        {failed && (
          <div className={styles.error}>
            Failed <ToastErrorIcon />
          </div>
        )}
      </div>
      {/* <LinearProgress variant="determinate" value={progress} /> */}
      <ProgressBar animated now={progress} style={{ height: 4 }} />
    </div>
  );
};
